export const TEXT_AREA_SETTINGS = {
    LENGTH: 4000,
    ROW: 10,
    ROW_HEIGHT: 20
};

export const CLASSIFIERS = {
    REFUND_REASON: 'RefundReason',
    REFUND_SOURCE: 'RefundSource',
    TRANSPORT_TYPE: 'TransportType',
    COMPENSATION_TYPE: 'CompensationType',
    COMPENSATION_VARIANT: 'CompensationVariant',
    DEMAND_CATEGORY: 'DemandCategory',
    BUS_ROUTE: 'BusRoute',
    BOAT_ROUTE: 'BoatRoute'
};

export const SERVICE_NEVER_RECEIVED = 'ServiceNeverShowedUp';
